

define(['squid/index', './directive'], function (squid) {

    (function exportProviders(angular) {
        angular && angular.exportProviders(module, exports, __dirname, __filename);
    })(window.angular);

    squid.module('xo-add-bank.addbank.route', ['squid', 'xo-add-bank.addbank.directive']).factory('$XOAddBankRoute', function ($ComponentRoute) {

        return $ComponentRoute.extend('AddRoute', {

            name: 'add',
            titleContent: 'asideHeader.addBank',
            directive: 'xo-add-bank',
            trackingData: {
                fptiState: 'add_bank'
            },
            loginRequired: true,
            children: []
        });
    });
});


/*****************
 ** WEBPACK FOOTER
 ** ./components/xo-wallet-components/src/add-bank/addbank/route.js
 ** module id = 252
 ** module chunks = 1
 **/